function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-metadata"
}, /*#__PURE__*/React.createElement("title", null, "Building"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-container",
  "data-width": 31,
  "data-height": 32
}, /*#__PURE__*/React.createElement("path", {
  className: "iconic-building-step iconic-building-step-bottom iconic-property-accent iconic-property-fill",
  d: "M0 31.037h31v1h-31z"
}), /*#__PURE__*/React.createElement("path", {
  className: "iconic-building-step iconic-building-step-middle iconic-property-accent iconic-property-fill",
  d: "M1 29.037h29v1h-29z"
}), /*#__PURE__*/React.createElement("path", {
  className: "iconic-building-step iconic-building-step-top iconic-property-accent iconic-property-fill",
  d: "M2 27h27v1h-27z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 1c.552 0 1 .448 1 1v24h11v-5h3v5h11v-24c0-.552.448-1 1-1h-27zm8 17h-5v-5h5v5zm0-8h-5v-5h5v5zm8 8h-5v-5h5v5zm0-8h-5v-5h5v5zm8 8h-5v-5h5v5zm0-8h-5v-5h5v5z",
  className: "iconic-building-facade iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  className: "iconic-building-rooftop iconic-property-fill",
  d: "M2 0h27v1h-27z"
}));

function SvgBuildingMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    "data-icon": "building",
    className: "iconic iconic-building iconic-size-md",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingMd);
export default __webpack_public_path__ + "static/media/building-md.f7f5e7db.svg";
export { ForwardRef as ReactComponent };